import { MainStatusConfig } from '../config/main-status.config';
import { MainStatusCodes } from '../enums/order-status.enums';
import { FilledStatusInfo, StatusInfo } from '../models/order-status.model';

export const getOrderStatus = (code: MainStatusCodes): StatusInfo => {
    return MainStatusConfig[code];
};

export const getDateForOrderStatusTracking = (status: StatusInfo, tracking: any): FilledStatusInfo => {
    return {
        ...status,
        date: status?.order !== 1 ? tracking?.fechaActualizacion : '',
    };
};
